<template>
  <VersaoLoader path="Login" />
</template>

<script>
import VersaoLoader from './VersaoLoader.vue'

export default {
  name: 'LoginVersao',
  components: { VersaoLoader }
}
</script>
